import React from 'react';

import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';

const TooltipWithTimer = (props) => {
  const tooltipDirection = props.tooltipDirection;
  const tooltipText = props.tooltipText;

  return(
    <Overlay
      target={props.target.current}
      show={props.show}
      placement={tooltipDirection}
      rootClose={true}
    >
      <Tooltip {...props}>
        {tooltipText}
      </Tooltip>
    </Overlay>
  )
}

export default TooltipWithTimer;